import type {TableRow, TableSpanRowProps} from './ApiTableSpanRow'

type TableRowProps = TableSpanRowProps & TableRow

export default function ApiTableRow({value, type, rowSpan, title, parent}: TableRowProps) {
    return <tr className='api-table__row'>
        {!!rowSpan &&
            <td
                className='api-table__key'
                rowSpan={rowSpan}
            >
                <div className='grid grid_rg-0 grid_justify-items-start'>
                    <span className='api-table__value'>
                        <b>{parent?.value}</b>
                    </span>
                    <span className='api-table__type'>
                        {parent?.type}
                    </span>
                </div>
            </td>
        }
        <td className='api-table__key'>
            <div className='grid'>
                <span className='api-table__value'>
                    <b>{title}</b>
                </span>
            </div>
        </td>
        <td className='api-table__key' colSpan={2}>
            <div className='grid grid_rg-0 grid_justify-items-start'>
                <span className='api-table__type'>
                    {type}
                </span>
                {/* TODO использовать pre */}
                <span className='api-table__value'>
                    {value}
                </span>
            </div>
        </td>
    </tr>
}
